import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import { 
    get_report_options_api,
    get_advance_report_dashboard_data_api 
} from '../controllers/dataController';
import DashboardDisplay from '../components/DashboardDisplay';
import { FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import SongsTable from '../components/SongsTable';

const AdvanceReportPage = () => {
    const [reportType, setReportType] = useState('label'); // 'label', 'artist_name', or 'registered_account'
    const [options, setOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [dashboardData, setDashboardData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState('');



    useEffect(() => {
        
       
        get_report_options_api(reportType)
            .then(data => {
                // For artist objects, sort by name. For strings, sort alphabetically.
                const sortedData = data.sort((a, b) => {
                    const nameA = a.name || a;
                    const nameB = b.name || b;
                    return nameA.localeCompare(nameB);
                });
                setOptions(sortedData);
            }).catch(error => {
                console.error(`Failed to fetch ${reportType}:`, error);
            }).finally(() => {
                setLoading(false);
            });
            
    }, [reportType]);

    const handleSelectionChange = (e) => {
        const selected = Array.from(e.target.selectedOptions, option => option.value);
        setSelectedOptions(selected);
    };

    const handle_report_type_change = (e) => {
        setOptions([]); 
        setSelectedOptions([]);
        setDashboardData(null);
        setLoading(true);
        setReportType(e.target.value);
    };
    const handleGenerateReport = () => {
        if (selectedOptions.length === 0) {
            alert('Please select at least one option.');
            return;
        }

        setLoading(true);
        setDashboardData(null);
        
        const data = {
            report_type: reportType,
            options: selectedOptions,
        };

        let reportTitle;
        if (reportType === 'registered_account') {
            const selectedNames = options
                .filter(opt => selectedOptions.includes(String(opt.pk)))
                .map(opt => opt.name);
            reportTitle = `Dashboard for Account(s): ${selectedNames.join(', ')}`;
        } else {
            const typeText = reportType === 'artist_name' ? 'Artist Name' : 'Label';
            reportTitle = `Dashboard for ${typeText}(s): ${selectedOptions.join(', ')}`;
        }
        setTitle(reportTitle);

        get_advance_report_dashboard_data_api(data).then(response => {
            setDashboardData(response.data);
        }).catch(error => {
            console.error("Failed to generate report:", error);
            alert("Failed to generate report.");
        }).finally(() => {
            setLoading(false);
        });
    };

    const renderOptions = () => {
        if (reportType === 'label' || reportType === 'artist_name') {
            return options.map(opt => <option key={opt} value={opt}>{opt}</option>);
        }
        if (reportType === 'registered_account') {
            return options.map(opt => <option key={opt.pk} value={opt.pk}>{opt.name}</option>);
        }
        return null;
    };

    return (
        <div className='relative'>
            {loading && (
                <div className="absolute inset-0 bg-background/30 flex justify-center items-center z-50">
                    <div className="spinner"></div>
                </div>
            )}
            <div className='absolute top-0 left-0 right-0'>
                <Header />
            </div>
            <div className="bg-background min-h-screen text-white pt-32 py-6 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">
                    <div className="flex items-center mb-6">
                        <Link to="/admin_dashboard" className="text-muted-foreground hover:text-primary mr-4">
                            <FaArrowLeft size={20} />
                        </Link>
                        <h2 className="text-2xl font-bold text-white">Advanced Reports</h2>
                    </div>
                    <div className="bg-gradient-card border border-border/50 rounded-lg shadow-xl p-6 mb-8">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            {/* Report Type Dropdown */}
                            <div>
                                <label htmlFor="reportType" className="block text-sm font-medium text-muted-foreground mb-2">Report Type</label>
                                <select
                                    id="reportType"
                                    value={reportType}
                                    onChange={(e) => handle_report_type_change(e)}
                                    className="w-full bg-secondary border border-border text-white rounded-md py-2 px-3 focus:outline-none focus:border-primary"
                                >
                                    <option value="label">Label</option>
                                    <option value="artist_name">Artist Name (from data)</option>
                                    <option value="registered_account">Registered Account</option>
                                </select>
                            </div>

                            {/* Options Dropdown */}
                            <div className='col-span-1 md:col-span-2'>
                                <label htmlFor="option" className="block text-sm font-medium text-muted-foreground mb-2">
                                    Select Option(s) (hold Ctrl/Cmd to select multiple)
                                </label>
                                <select
                                    id="option"
                                    multiple={true}
                                    value={selectedOptions}
                                    onChange={handleSelectionChange}
                                    className="w-full h-40 bg-secondary border border-border text-white rounded-md py-2 px-3 focus:outline-none focus:border-primary"
                                    disabled={loading || options.length === 0}
                                >
                                    {renderOptions()}
                                </select>
                            </div>

                            {/* Generate Button */}
                            <div className="flex items-center md:col-start-3">
                                <button
                                    onClick={handleGenerateReport}
                                    className="w-full bg-primary hover:bg-gold-dark text-primary-foreground font-bold py-2 px-4 rounded-md transition-colors"
                                    disabled={loading || selectedOptions.length === 0}
                                >
                                    {loading ? <div className="spinner"></div> : 'Generate Report'}
                                </button>
                            </div>
                        </div>
                    </div>

                    {dashboardData && (
                        <>
                            <DashboardDisplay dashboardData={dashboardData} title={title} />
                            {dashboardData.songs && (
                                <SongsTable songsData={dashboardData.songs} isAdmin={true} />
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdvanceReportPage;